import { AddressFragment } from 'src/graphql/generated/graphql'
import { formatCountriesAndRegions } from 'src/helpers/formatCountriesAndRegions'
import { useSelector } from 'src/hooks'
import { useDetailedCountries } from 'src/react_query'

const useIsAddressValid = (orderRAddress?: AddressFragment) => {
  const account = useSelector(state => state.user.account)
  const returnAddress = orderRAddress ? orderRAddress : account?.shippingAddress

  const {
    isLoading: isUnresolved,
    error,
    data: detailedCountries,
  } = useDetailedCountries()

  const { regions, isRegionsUnavailable } =
    !isUnresolved && !error && detailedCountries !== undefined
      ? formatCountriesAndRegions(detailedCountries, returnAddress?.country)
      : { regions: undefined, isRegionsUnavailable: false }
  return (
    (regions && regions.includes(returnAddress?.state ?? '')) ||
    isRegionsUnavailable
  )
}

export default useIsAddressValid
